import { render } from "./clozeTest.vue?vue&type=template&id=e9fc615e&scoped=true"
import script from "./clozeTest.vue?vue&type=script&lang=js"
export * from "./clozeTest.vue?vue&type=script&lang=js"

import "./clozeTest.vue?vue&type=style&index=0&id=e9fc615e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9fc615e"]])

export default __exports__